import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { SessionService } from "./session.service";

export const orgIsActiveGuard: CanActivateFn = async (route, state) => {
    const sessionService = inject(SessionService);
    const profileData = sessionService.profileData();

    if (!profileData?.orgIsActivated) {
        return false;
    }

    return true;
};
